import React from "react";
import svgPaths from "./vector-man";

export default function VectorMan({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 695 506">
      <g clipPath="url(#clip0_35_255)" id="vector man">
        <path d={svgPaths.p3672c480} fill="url(#paint0_linear_35_255)" id="Vector" />
        <path d={svgPaths.pfa58d00} fill="var(--fill-0, #68ADB5)" id="Vector_2" />
        <path d={svgPaths.p22823580} fill="var(--fill-0, #ED5C32)" id="Vector_3" />
        <path d={svgPaths.p15cd0670} fill="var(--fill-0, #6DB3AC)" id="Vector_4" />
        <path d={svgPaths.p58b7600} fill="var(--fill-0, #EDAF37)" id="Vector_5" />
        <path d={svgPaths.p12bc0a80} fill="var(--fill-0, #EE5E32)" id="Vector_6" />
        <path d={svgPaths.p8a4e100} fill="url(#paint1_linear_35_255)" id="Vector_7" />
        <path d={svgPaths.p3a5f5a80} fill="var(--fill-0, #0944BF)" id="Vector_8" />
        <path d={svgPaths.pb21d80} fill="var(--fill-0, #035F2B)" id="Vector_9" />
        <path d={svgPaths.p244a0500} fill="var(--fill-0, #DC7E60)" id="Vector_10" />
        <path d={svgPaths.p207a3b00} fill="url(#paint2_linear_35_255)" id="Vector_11" />
        <path d={svgPaths.p1773d470} fill="var(--fill-0, #EEB23A)" id="Vector_12" />
        <path d={svgPaths.p1a6b6800} fill="var(--fill-0, #F7F7F7)" id="Vector_13" />
        <path d={svgPaths.p38df4180} fill="var(--fill-0, #EEB136)" id="Vector_14" />
        <path d={svgPaths.p20a43f00} fill="url(#paint3_linear_35_255)" id="Vector_15" />
        <path d={svgPaths.p3bcf3400} fill="var(--fill-0, #E43D10)" id="Vector_16" />
        <path d={svgPaths.p14680d00} fill="var(--fill-0, #EE5B2F)" id="Vector_17" />
        <path d={svgPaths.p3dccb380} fill="var(--fill-0, #DE3D11)" id="Vector_18" />
        <path d={svgPaths.p1266c400} fill="var(--fill-0, #0F43BA)" id="Vector_19" />
        <path d={svgPaths.p1dfafc0} fill="var(--fill-0, #72AFB1)" id="Vector_20" />
        <path d={svgPaths.p29eca080} fill="var(--fill-0, #DD4113)" id="Vector_21" />
        <path d={svgPaths.p1634e900} fill="var(--fill-0, #CE7457)" id="Vector_22" />
        <path d={svgPaths.p3bb10c00} fill="var(--fill-0, #7AA9BD)" id="Vector_23" />
        <path d={svgPaths.p28c94d00} fill="var(--fill-0, #E83F1B)" id="Vector_24" />
        <path d={svgPaths.p1a73c200} fill="var(--fill-0, #0F43B7)" id="Vector_25" />
        <path d={svgPaths.p21eb3900} fill="var(--fill-0, #E63B10)" id="Vector_26" />
        <path d={svgPaths.p28063000} fill="var(--fill-0, #E83A10)" id="Vector_27" />
        <path d={svgPaths.p33c51170} fill="var(--fill-0, #F8F7F6)" id="Vector_28" />
        <path d={svgPaths.p3e55800} fill="var(--fill-0, #F8F6F6)" id="Vector_29" />
        <path d={svgPaths.p3dc6b080} fill="var(--fill-0, #FCFBF5)" id="Vector_30" />
        <path d={svgPaths.p2275f000} fill="var(--fill-0, #FCFBF6)" id="Vector_31" />
        <path d={svgPaths.p39ce0380} fill="var(--fill-0, #E93C11)" id="Vector_32" />
        <path d={svgPaths.p3ef75500} fill="var(--fill-0, #F9F8F6)" id="Vector_33" />
        <path d={svgPaths.p1a922200} fill="var(--fill-0, #F8F8F6)" id="Vector_34" />
        <path d={svgPaths.p2fc26d00} fill="var(--fill-0, #F9F7E5)" id="Vector_35" />
        <path d={svgPaths.p12305d80} fill="var(--fill-0, #CD4C2D)" id="Vector_36" />
        <path d={svgPaths.p237df280} fill="var(--fill-0, #2B3A89)" id="Vector_37" />
        <path d={svgPaths.p1de3b200} fill="var(--fill-0, #F6F5F3)" id="Vector_38" />
        <path d={svgPaths.p7d9b170} fill="var(--fill-0, #B7AF72)" id="Vector_39" />
        <path d={svgPaths.p393dd900} fill="var(--fill-0, #213E8B)" id="Vector_40" />
        <path d={svgPaths.p2140d080} fill="var(--fill-0, #F7F7F4)" id="Vector_41" />
        <path d={svgPaths.p328f4b20} fill="var(--fill-0, #E7F6F8)" id="Vector_42" />
        <path d={svgPaths.p18a64a80} fill="var(--fill-0, #AB5643)" id="Vector_43" />
        <path d={svgPaths.p492c700} fill="var(--fill-0, #AA5644)" id="Vector_44" />
        <path d={svgPaths.p1206b600} fill="var(--fill-0, #DD4321)" id="Vector_45" />
        <path d={svgPaths.p35c49e00} fill="var(--fill-0, #DD411E)" id="Vector_46" />
        <path d={svgPaths.p2a8d9a80} fill="var(--fill-0, #6F94BB)" id="Vector_47" />
        <path d={svgPaths.p3abd6100} fill="var(--fill-0, #3459B6)" id="Vector_48" />
        <path d={svgPaths.p177bce00} fill="var(--fill-0, #F6E7D5)" id="Vector_49" />
        <path d={svgPaths.p93380} fill="var(--fill-0, #F7EBD7)" id="Vector_50" />
        <path d={svgPaths.p19733f00} fill="var(--fill-0, #C05336)" id="Vector_51" />
        <path d={svgPaths.p3ccb9800} fill="var(--fill-0, #F7E7D5)" id="Vector_52" />
        <path d={svgPaths.p3365fe40} fill="var(--fill-0, #F7EBDC)" id="Vector_53" />
        <path d={svgPaths.p1868cf00} fill="var(--fill-0, #F8EAD7)" id="Vector_54" />
        <path d={svgPaths.p7cc0200} fill="var(--fill-0, #BE583B)" id="Vector_55" />
        <path d={svgPaths.p3523e080} fill="var(--fill-0, #F8EBDD)" id="Vector_56" />
        <path d={svgPaths.p1b303e00} fill="var(--fill-0, #F8E8D4)" id="Vector_57" />
        <path d={svgPaths.p16cf0400} fill="var(--fill-0, #F8E7D2)" id="Vector_58" />
        <path d={svgPaths.p3d362d00} fill="var(--fill-0, #C04C30)" id="Vector_59" />
        <path d={svgPaths.p2c066100} fill="var(--fill-0, #DD7D60)" id="Vector_60" />
        <path d={svgPaths.p3d38ae80} fill="var(--fill-0, #EDAF37)" id="Vector_61" />
        <path d={svgPaths.p8ddf200} fill="var(--fill-0, #ECAD34)" id="Vector_62" />
        <path d={svgPaths.p6739500} fill="var(--fill-0, #EFBB66)" id="Vector_63" />
        <path d={svgPaths.p290fd880} fill="var(--fill-0, #F1B956)" id="Vector_64" />
        <path d={svgPaths.p34ffc200} fill="var(--fill-0, #F0BC5B)" id="Vector_65" />
        <path d={svgPaths.p24c46780} fill="var(--fill-0, #E7A11B)" id="Vector_66" />
        <path d={svgPaths.p27575a00} fill="var(--fill-0, #EEB23F)" id="Vector_67" />
        <path d={svgPaths.p152a500} fill="var(--fill-0, #EDAE36)" id="Vector_68" />
        <path d={svgPaths.p29111980} fill="var(--fill-0, #EAAA27)" id="Vector_69" />
        <path d={svgPaths.p31463700} fill="var(--fill-0, #DA7A5D)" id="Vector_70" />
        <path d={svgPaths.p1b15180} fill="var(--fill-0, #EDB132)" id="Vector_71" />
        <path d={svgPaths.p2ac8bd80} fill="var(--fill-0, #F7F7F6)" id="Vector_72" />
        <path d={svgPaths.p364e500} fill="var(--fill-0, #F9F8F5)" id="Vector_73" />
        <path d={svgPaths.p21211a00} fill="var(--fill-0, #FCF6EC)" id="Vector_74" />
        <path d={svgPaths.p5287b00} fill="var(--fill-0, #094E6A)" id="Vector_75" />
        <path d={svgPaths.p6906500} fill="var(--fill-0, #F9F6F2)" id="Vector_76" />
        <path d={svgPaths.p11074f00} fill="var(--fill-0, #E14712)" id="Vector_77" />
        <path d={svgPaths.p10199b00} fill="var(--fill-0, #1E0706)" id="Vector_78" />
        <path d={svgPaths.p30770a00} fill="var(--fill-0, #F8F2E0)" id="Vector_79" />
        <path d={svgPaths.p2f1bad00} fill="var(--fill-0, #F8EEE2)" id="Vector_80" />
        <path d={svgPaths.p31c50970} fill="var(--fill-0, #EE3F12)" id="Vector_81" />
        <path d={svgPaths.pdda7800} fill="var(--fill-0, #F28D3B)" id="Vector_82" />
        <path d={svgPaths.p26353400} fill="var(--fill-0, #F2873D)" id="Vector_83" />
        <path d={svgPaths.p3a04cd70} fill="var(--fill-0, #F08236)" id="Vector_84" />
        <path d={svgPaths.p10290f00} fill="var(--fill-0, #F3833B)" id="Vector_85" />
        <path d={svgPaths.p23ba8ec0} fill="var(--fill-0, #E7A11B)" id="Vector_86" />
        <path d={svgPaths.p20dd4680} fill="var(--fill-0, #E7A11B)" id="Vector_87" />
        <path d={svgPaths.p21499a00} fill="var(--fill-0, #ECAD34)" id="Vector_88" />
        <path d={svgPaths.pd461300} fill="var(--fill-0, #EAAA27)" id="Vector_89" />
        <path d={svgPaths.p3b791800} fill="var(--fill-0, #EDAF37)" id="Vector_90" />
        <path d={svgPaths.p2c398100} fill="var(--fill-0, #E7A11B)" id="Vector_91" />
        <path d={svgPaths.pd11c100} fill="var(--fill-0, #EAAA27)" id="Vector_92" />
        <path d={svgPaths.p3082800} fill="var(--fill-0, #025424)" id="Vector_93" />
        <path d={svgPaths.p18320680} fill="var(--fill-0, #1045BB)" id="Vector_94" />
        <path d={svgPaths.p225d0280} fill="var(--fill-0, #2456C2)" id="Vector_95" />
        <path d={svgPaths.p3a450600} fill="var(--fill-0, #F6F6F6)" id="Vector_96" />
        <path d={svgPaths.p3c1eca00} fill="var(--fill-0, #F6F7F7)" id="Vector_97" />
        <path d={svgPaths.p17d9ae80} fill="var(--fill-0, #F6F7F7)" id="Vector_98" />
        <path d={svgPaths.p113bd80} fill="var(--fill-0, #F5F6F6)" id="Vector_99" />
        <path d={svgPaths.p8f1cfc0} fill="var(--fill-0, #F6F7F7)" id="Vector_100" />
        <path d={svgPaths.p2b06c580} fill="var(--fill-0, #F5F7F7)" id="Vector_101" />
        <path d={svgPaths.p2ce9af00} fill="var(--fill-0, #F4F7F7)" id="Vector_102" />
        <path d={svgPaths.p4e92300} fill="var(--fill-0, #F2F8F7)" id="Vector_103" />
        <path d={svgPaths.p36e30fc0} fill="var(--fill-0, #F3F6F7)" id="Vector_104" />
        <path d={svgPaths.p27e37980} fill="var(--fill-0, #DFD9CD)" id="Vector_105" />
        <path d={svgPaths.p27aca200} fill="var(--fill-0, #2456C2)" id="Vector_106" />
        <path d={svgPaths.p37dab700} fill="var(--fill-0, #7A9F0D)" id="Vector_107" />
        <path d={svgPaths.p1185eb80} fill="var(--fill-0, #EA3C10)" id="Vector_108" />
        <path d={svgPaths.p14d5ec00} fill="var(--fill-0, #F9F9F8)" id="Vector_109" />
        <path d={svgPaths.p3df3d900} fill="var(--fill-0, #F8F6F4)" id="Vector_110" />
        <path d={svgPaths.p25e32980} fill="var(--fill-0, #F7F6F4)" id="Vector_111" />
        <path d={svgPaths.p2dbb4680} fill="var(--fill-0, #F7F6F4)" id="Vector_112" />
        <path d={svgPaths.p2e277780} fill="var(--fill-0, #F7F5F4)" id="Vector_113" />
        <path d={svgPaths.p2e79ac00} fill="var(--fill-0, #F7F5F3)" id="Vector_114" />
        <path d={svgPaths.p16353392} fill="var(--fill-0, #F7F6F4)" id="Vector_115" />
        <path d={svgPaths.p3ac26800} fill="var(--fill-0, #CD6041)" id="Vector_116" />
        <path d={svgPaths.p5c7af00} fill="var(--fill-0, #F6F4E2)" id="Vector_117" />
        <path d={svgPaths.p153adb00} fill="var(--fill-0, #0E0908)" id="Vector_118" />
        <path d={svgPaths.p34d3ac00} fill="var(--fill-0, #DF795B)" id="Vector_119" />
        <path d={svgPaths.p1b142100} fill="var(--fill-0, #F9FAF9)" id="Vector_120" />
        <path d={svgPaths.p2f083a00} fill="var(--fill-0, #F7F7F7)" id="Vector_121" />
        <path d={svgPaths.p234f8080} fill="var(--fill-0, #F6F7F7)" id="Vector_122" />
        <path d={svgPaths.p3a668200} fill="var(--fill-0, #F7F7F7)" id="Vector_123" />
        <path d={svgPaths.p3f2b1c80} fill="var(--fill-0, #F6F7F7)" id="Vector_124" />
        <path d={svgPaths.p25217100} fill="var(--fill-0, #090909)" id="Vector_125" />
        <path d={svgPaths.p2ea4a300} fill="var(--fill-0, #0E100F)" id="Vector_126" />
        <path d={svgPaths.p1c1cb600} fill="var(--fill-0, #0B0B0B)" id="Vector_127" />
        <path d={svgPaths.p5d47d80} fill="var(--fill-0, #0C0D0B)" id="Vector_128" />
        <path d={svgPaths.p32377200} fill="var(--fill-0, #709C4C)" id="Vector_129" />
        <path d={svgPaths.p25826280} fill="var(--fill-0, #F9F8F5)" id="Vector_130" />
        <path d={svgPaths.p16bdb900} fill="var(--fill-0, #F8F8F7)" id="Vector_131" />
        <path d={svgPaths.p78cfc80} fill="var(--fill-0, #F7F7F7)" id="Vector_132" />
        <path d={svgPaths.p1ad60580} fill="var(--fill-0, #EA3C10)" id="Vector_133" />
        <path d={svgPaths.p2040d200} fill="var(--fill-0, #FAFAFA)" id="Vector_134" />
        <path d={svgPaths.p329f8d80} fill="var(--fill-0, #E43A11)" id="Vector_135" />
        <path d={svgPaths.p254aacc0} fill="var(--fill-0, #789F0D)" id="Vector_136" />
        <path d={svgPaths.p3c450400} fill="var(--fill-0, #0D42B2)" id="Vector_137" />
        <path d={svgPaths.p1b20db80} fill="var(--fill-0, #C44D11)" id="Vector_138" />
        <path d={svgPaths.p13637900} fill="var(--fill-0, #EE4213)" id="Vector_139" />
        <path d={svgPaths.p84c0570} fill="var(--fill-0, #90A29A)" id="Vector_140" />
        <path d={svgPaths.p12828600} fill="var(--fill-0, #EA7F16)" id="Vector_141" />
        <path d={svgPaths.p3ca8f000} fill="var(--fill-0, #EA6413)" id="Vector_142" />
        <path d={svgPaths.p39cd100} fill="var(--fill-0, #E83E14)" id="Vector_143" />
        <path d={svgPaths.p32022a00} fill="var(--fill-0, #C15C57)" id="Vector_144" />
        <path d={svgPaths.p29996500} fill="var(--fill-0, #DCDEDD)" id="Vector_145" />
        <path d={svgPaths.p2397f900} fill="var(--fill-0, #D6E1E7)" id="Vector_146" />
        <path d={svgPaths.pf651400} fill="var(--fill-0, #2656C3)" id="Vector_147" />
        <path d={svgPaths.p3cc22380} fill="var(--fill-0, #020202)" id="Vector_148" />
        <path d={svgPaths.p3a990600} fill="var(--fill-0, #F1F6F5)" id="Vector_149" />
        <path d={svgPaths.p293ac600} fill="var(--fill-0, #EFF6F6)" id="Vector_150" />
        <path d={svgPaths.p11a31e00} fill="var(--fill-0, #559132)" id="Vector_151" />
        <path d={svgPaths.p3df15000} fill="var(--fill-0, #4A8B32)" id="Vector_152" />
        <path d={svgPaths.p26f3d800} fill="var(--fill-0, #5E9A38)" id="Vector_153" />
        <path d={svgPaths.p20ebe480} fill="var(--fill-0, #DD7D60)" id="Vector_154" />
        <path d={svgPaths.p3d6fc900} fill="var(--fill-0, #DD7D60)" id="Vector_155" />
        <path d={svgPaths.pf49bd80} fill="var(--fill-0, #DD7D60)" id="Vector_156" />
        <path d={svgPaths.p16d3a80} fill="var(--fill-0, #260907)" id="Vector_157" />
        <path d={svgPaths.p3cf2f700} fill="var(--fill-0, #230807)" id="Vector_158" />
        <path d={svgPaths.p35de6080} fill="var(--fill-0, #DD7D60)" id="Vector_159" />
        <path d={svgPaths.p275a0fc0} fill="var(--fill-0, #DD7D60)" id="Vector_160" />
        <path d={svgPaths.p1a289700} fill="var(--fill-0, #F7F6F4)" id="Vector_161" />
        <path d={svgPaths.p3e5cf480} fill="var(--fill-0, #7A9A0A)" id="Vector_162" />
        <path d={svgPaths.p3b49e280} fill="url(#paint4_linear_35_255)" id="Vector_163" />
        <path d={svgPaths.p171e770} fill="var(--fill-0, #030303)" id="Vector_164" />
        <path d={svgPaths.p6f0d600} fill="var(--fill-0, #C0B07B)" id="Vector_165" />
        <path d={svgPaths.p2d20cc80} fill="var(--fill-0, #2555C2)" id="Vector_166" />
        <path d={svgPaths.p3335f000} fill="var(--fill-0, #F0CD8F)" id="Vector_167" />
        <path d={svgPaths.p126f9300} fill="var(--fill-0, #F5F5F4)" id="Vector_168" />
        <path d={svgPaths.p351be800} fill="var(--fill-0, #2456C2)" id="Vector_169" />
        <path d={svgPaths.p115945a0} fill="var(--fill-0, #88B3C7)" id="Vector_170" />
        <path d={svgPaths.p188e5d00} fill="var(--fill-0, #D0E9F1)" id="Vector_171" />
        <path d={svgPaths.p2f631980} fill="var(--fill-0, #E83E1A)" id="Vector_172" />
        <path d={svgPaths.p66f3d80} fill="var(--fill-0, #C04C30)" id="Vector_173" />
        <path d={svgPaths.pa6f6e00} fill="var(--fill-0, #0C46BF)" id="Vector_174" />
        <path d={svgPaths.ped93e00} fill="var(--fill-0, #E0F1F6)" id="Vector_175" />
        <path d={svgPaths.p1f064680} fill="var(--fill-0, #0C43BC)" id="Vector_176" />
        <path d={svgPaths.p212f3000} fill="var(--fill-0, #C2533A)" id="Vector_177" />
        <path d={svgPaths.p20521d00} fill="var(--fill-0, #010101)" id="Vector_178" />
        <path d={svgPaths.p3de10c00} fill="var(--fill-0, #DBB063)" id="Vector_179" />
        <path d={svgPaths.p30ab0900} fill="var(--fill-0, #1A0804)" id="Vector_180" />
        <path d={svgPaths.p309eec00} fill="var(--fill-0, #F5DFB5)" id="Vector_181" />
        <path d={svgPaths.p3d5b2b80} fill="var(--fill-0, #F3DDB0)" id="Vector_182" />
        <path d={svgPaths.p1a4cfa00} fill="var(--fill-0, #F3DCAE)" id="Vector_183" />
        <path d={svgPaths.p1f351500} fill="var(--fill-0, #E34215)" id="Vector_184" />
        <path d={svgPaths.p32f0e360} fill="var(--fill-0, #FAECB9)" id="Vector_185" />
        <path d={svgPaths.p2583d280} fill="var(--fill-0, #F9E9B8)" id="Vector_186" />
        <path d={svgPaths.p29030a00} fill="var(--fill-0, #D7AE5E)" id="Vector_187" />
        <path d={svgPaths.p236844f0} fill="var(--fill-0, #DEB55B)" id="Vector_188" />
        <path d={svgPaths.pf764480} fill="var(--fill-0, #F8EAB9)" id="Vector_189" />
        <path d={svgPaths.p354f1800} fill="var(--fill-0, #F1B956)" id="Vector_190" />
        <path d={svgPaths.p12a32680} fill="var(--fill-0, #160805)" id="Vector_191" />
        <path d={svgPaths.p36ce500} fill="var(--fill-0, #F6BBC0)" id="Vector_192" />
        <path d={svgPaths.p3aa34300} fill="var(--fill-0, #F6BBBD)" id="Vector_193" />
        <path d={svgPaths.p1cdf16f0} fill="var(--fill-0, #ECAD34)" id="Vector_194" />
        <path d={svgPaths.p12731000} fill="var(--fill-0, #D6A639)" id="Vector_195" />
        <path d={svgPaths.p26e27780} fill="var(--fill-0, #FAEFBB)" id="Vector_196" />
        <path d={svgPaths.p225a3e80} fill="var(--fill-0, #FAECB8)" id="Vector_197" />
        <path d={svgPaths.p6acf600} fill="var(--fill-0, #FAEDBE)" id="Vector_198" />
        <path d={svgPaths.p3ecea700} fill="var(--fill-0, #DCB361)" id="Vector_199" />
        <path d={svgPaths.p33a73980} fill="var(--fill-0, #F9E9B2)" id="Vector_200" />
        <path d={svgPaths.p3fcc600} fill="var(--fill-0, #DCB96C)" id="Vector_201" />
        <path d={svgPaths.p167e7580} fill="var(--fill-0, #F9E9B3)" id="Vector_202" />
        <path d={svgPaths.p3c26c300} fill="var(--fill-0, #F8E7B0)" id="Vector_203" />
        <path d={svgPaths.p234cab00} fill="var(--fill-0, #ABAB4D)" id="Vector_204" />
        <path d={svgPaths.p38f37180} fill="var(--fill-0, #AFAC50)" id="Vector_205" />
        <path d={svgPaths.p12184ef0} fill="var(--fill-0, #A8A84E)" id="Vector_206" />
        <path d={svgPaths.p30056500} fill="var(--fill-0, #A8AF55)" id="Vector_207" />
        <path d={svgPaths.pc106c80} fill="var(--fill-0, #B7B155)" id="Vector_208" />
        <path d={svgPaths.p21c3e000} fill="var(--fill-0, #ADAA9A)" id="Vector_209" />
        <path d={svgPaths.pf1a4900} fill="var(--fill-0, #AEA995)" id="Vector_210" />
        <path d={svgPaths.pfa45800} fill="var(--fill-0, #A9AA99)" id="Vector_211" />
        <path d={svgPaths.p2c7b4980} fill="var(--fill-0, #AEAC9E)" id="Vector_212" />
        <path d={svgPaths.p184dae00} fill="var(--fill-0, #A0A38A)" id="Vector_213" />
        <path d={svgPaths.p31c51300} fill="var(--fill-0, #B2AE9B)" id="Vector_214" />
        <path d={svgPaths.p1c03600} fill="var(--fill-0, #0C0505)" id="Vector_215" />
        <path d={svgPaths.p1ca1e200} fill="var(--fill-0, #F8F6F4)" id="Vector_216" />
        <path d={svgPaths.p32297600} fill="var(--fill-0, #F8F7F5)" id="Vector_217" />
        <path d={svgPaths.p19d6aa00} fill="var(--fill-0, #9F635C)" id="Vector_218" />
        <path d={svgPaths.pd1cdb80} fill="var(--fill-0, #F2FBFA)" id="Vector_219" />
        <path d={svgPaths.p3e9a8480} fill="var(--fill-0, #F2FBFA)" id="Vector_220" />
        <path d={svgPaths.p346a0700} fill="var(--fill-0, #F2FBFA)" id="Vector_221" />
        <path d={svgPaths.p3d874f80} fill="var(--fill-0, #F2FBFA)" id="Vector_222" />
        <path d={svgPaths.p1249100} fill="var(--fill-0, #9CA9B3)" id="Vector_223" />
        <path d={svgPaths.p268baf00} fill="var(--fill-0, #9DAAB4)" id="Vector_224" />
        <path d={svgPaths.p39418e80} fill="var(--fill-0, #9BA8B4)" id="Vector_225" />
        <path d={svgPaths.pcc32100} fill="var(--fill-0, #9FAAB3)" id="Vector_226" />
        <path d={svgPaths.p17964c00} fill="var(--fill-0, #A3AEB7)" id="Vector_227" />
        <path d={svgPaths.p2fc06072} fill="var(--fill-0, #F2FBFA)" id="Vector_228" />
        <path d={svgPaths.paf48300} fill="var(--fill-0, #F2FBFA)" id="Vector_229" />
        <path d={svgPaths.p22e78300} fill="var(--fill-0, #7A8B54)" id="Vector_230" />
        <path d={svgPaths.p70af000} fill="var(--fill-0, #7A8B54)" id="Vector_231" />
        <path d={svgPaths.p20e0b500} fill="var(--fill-0, #9EB9B3)" id="Vector_232" />
        <path d={svgPaths.p10af1a70} fill="var(--fill-0, #160604)" id="Vector_233" />
        <path d={svgPaths.pc73ea00} fill="var(--fill-0, #9DAAB5)" id="Vector_234" />
        <path d={svgPaths.p27fdf500} fill="var(--fill-0, #A1ADB6)" id="Vector_235" />
        <path d={svgPaths.p231d5580} fill="var(--fill-0, #9DA9B4)" id="Vector_236" />
        <path d={svgPaths.p21b5100} fill="var(--fill-0, #9DAAB5)" id="Vector_237" />
      </g>
      <defs>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_35_255" x1="226.89" x2="420.65" y1="197.85" y2="227.38">
          <stop stopColor="#E24211" />
          <stop offset="0.26" stopColor="#EB5613" />
          <stop offset="1" stopColor="#E33A0E" />
        </linearGradient>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint1_linear_35_255" x1="455.29" x2="521.32" y1="366.85" y2="444.59">
          <stop stopColor="#EA8E1F" />
          <stop offset="0.61" stopColor="#ED4712" />
          <stop offset="1" stopColor="#E03F17" />
        </linearGradient>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint2_linear_35_255" x1="122.18" x2="155.22" y1="396.76" y2="461.86">
          <stop stopColor="#EC9918" />
          <stop offset="1" stopColor="#DC4F16" />
        </linearGradient>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint3_linear_35_255" x1="441.38" x2="387.18" y1="389.92" y2="459.26">
          <stop stopColor="#76AA9B" />
          <stop offset="0.48" stopColor="#8FB9D3" />
          <stop offset="1" stopColor="#98B8D5" />
        </linearGradient>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint4_linear_35_255" x1="334.88" x2="379.15" y1="422.94" y2="453.86">
          <stop stopColor="#1840A8" />
          <stop offset="1" stopColor="#3E66C1" />
        </linearGradient>
        <clipPath id="clip0_35_255">
          <rect fill="white" height="505.22" width="694.6" />
        </clipPath>
      </defs>
    </svg>
  );
}
